import type queryString from 'query-string'

type QueryParams = queryString.ParsedQuery<string>

type PermittedQueryParams = Record<string, string | string[] | number | null>

function parsePermittedQueryParams(queryParams: QueryParams, permittedKeys: Array<string>) {
  const permittedParams = Object.keys(queryParams).reduce((acc: PermittedQueryParams, key) => {
    if (permittedKeys.includes(key)) {
      const value = queryParams[key]
      acc[key] = Number.isNaN(Number(value)) ? value : Number(value)
    }

    return acc
  }, {})

  return permittedParams
}

export default parsePermittedQueryParams
